// src/components/Auth/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requiredPermission && !user.permisos[requiredPermission]) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default ProtectedRoute;
